import { render, staticRenderFns } from "./cp-tab.vue?vue&type=template&id=a2003da4"
import script from "./cp-tab.vue?vue&type=script&lang=js"
export * from "./cp-tab.vue?vue&type=script&lang=js"
import style0 from "./cp-tab.vue?vue&type=style&index=0&id=a2003da4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports